import _ from "lodash";
import React, { useEffect, useState } from "react";
import { SelectDropdown } from "@toddle-edu/ds-web";
import classes from "./DurationAndPrescribedPractical.scss";
import TimeSelector from "UIComponents/TimeSelector";

const pp_options = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

const DurationAndPrescribedPractical = props => {
  const [duration, setDuration] = useState("");
  const [isPP, setPP] = useState("");

  const { updateInputField, t, assessmentMode } = props;

  useEffect(() => {
    const assessmentFields = _.get(props, "assessmentFields", {});
    if (assessmentFields) {
      const oldDuration = _.get(
        _.find(assessmentFields, field =>
          _.isEqual(_.get(field, "uid"), "duration")
        ),
        "value"
      );

      if (!_.isNull(oldDuration) && oldDuration !== 0) {
        setDuration(oldDuration);
      }

      const oldPP = _.get(
        _.find(assessmentFields, field => _.isEqual(_.get(field, "uid"), "pp")),
        "value"
      );
      if (!_.isNull(oldPP)) {
        if (oldPP) {
          setPP({ label: "Yes", value: true });
        } else {
          setPP({ label: "No", value: false });
        }
      } else {
        if (assessmentMode === "edit") {
          setPP({ label: "No", value: false });
        }
      }
    }
  }, []);

  const onChangeDuration = ({ duration = 0 }) => {
    setDuration(duration);
    updateInputField({ duration });
  };

  const onChangePP = value => {
    setPP(value);
    const ppVal = _.get(value, "value", "");
    if (ppVal !== "") {
      updateInputField({ pp: ppVal ? true : false });
    } else {
      updateInputField({ pp: false });
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.termsDropdown}>
        <div className="text-label-2">
          {t("unitPlanTemplate:le_DP_PRACTICAL_ACTIVITY_pp_label")}
        </div>
        <SelectDropdown
          options={pp_options}
          size={"medium"}
          placeholder={t("common:select")}
          value={isPP}
          onChange={onChangePP}
        />
      </div>
      <div className={classes.termsDropdown}>
        <TimeSelector
          {...props}
          storeValueInSeconds={true}
          SelectedTimeformat="H [h] mm [m]"
          name={"duration"}
          value={duration ? duration : 0}
          updateInputField={onChangeDuration}
          placeholder={"common:select_with_label"}
          timeComponentStyle={{ height: "40px" }}
          borderStyle={{ borderRadius: "6px" }}
        />
      </div>
    </div>
  );
};

export default DurationAndPrescribedPractical;
